import React from "react";
import { getS3Url } from "./halper";

// export const API_BASE_URL = "https://adminapi.vakilkaro.com/api/v1";
export const API_BASE_URL = "https://maruticreations.in/api/v1";
export const API_BASE_URL_HRM = "https://adminapi.vakilkaro.com/hrm";
// export const API_BASE_URL = "http://localhost:3001/api/v1";
// export const API_BASE_URL_HRM = "http://localhost:8000/hrm";
export const S3_BASE_URL = "https://sqlappupload.s3.ap-south-1.amazonaws.com/micro-finence";

//Company name
const companyDetails = sessionStorage.getItem("companyDetails");

export const COMPANY_NAME = companyDetails
  ? JSON.parse(companyDetails)?.companyName
  : "";
export const COMPANY_EMAiL = companyDetails
  ? JSON.parse(companyDetails)?.email
  : "";
export const COMPANY_MO = companyDetails
  ? JSON.parse(companyDetails)?.phoneNumber
  : "";

export const COMPANY_Address = companyDetails
  ? JSON.parse(companyDetails)?.companyAddress
  : "";

const url = getS3Url(JSON.parse(companyDetails)?.company_logo);

export const COMPANY_AddLogo = companyDetails ? url : "";

export const Loader = () => {
  return <span className="loader-new" />;
};

export const formatDate = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);

  return date
    .toLocaleString("en-IN", {
      timeZone: "Asia/Kolkata",
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false,
    })
    .replace(",", "");
};

export const MODULE_GROUPS = {
  "EMI Calculator": ["emi-calculator"],
  Directors: ["directors", "directorsCapital"],
  Branches: ["branches"],
  Product: ["products"],
  "Manage Staff Data": ["staff-details", "addstaff"],
  Loan: [
    "apply-loan",
    "verification",
    "track-customer-details",
    "download-customer-details",
  ],
  HRM: [
    "employee",
    "attendance",
    "recruitment",
    "payroll",
    "holiday",
    "salary",
    "appraisal",
    "offer-letter",
    "employee-exit",
    "leave",
    "experienceletter",
    "session",
  ],
  Accounting: [
    "profitandlosslist",
    "bankstatement",
    "banking",
    "ledger",
    "masteraccount",
    "journals",
    "payment",
  ],
  "Loan Status": ["loan-status"],
  Collections: ["payment-collection", "emi-details"],
  "EMI Record": ["emirecords"],
  "Group Loan": ["addgroup", "grouplist"],
};

export const numberToWords = (num) => {
  const a = [
    "", "One", "Two", "Three", "Four", "Five", "Six", "Seven", "Eight", "Nine", "Ten",
    "Eleven", "Twelve", "Thirteen", "Fourteen", "Fifteen", "Sixteen", "Seventeen",
    "Eighteen", "Nineteen",
  ];
  const b = [
    "", "", "Twenty", "Thirty", "Forty", "Fifty", "Sixty", "Seventy", "Eighty", "Ninety",
  ];
  if ((num = num.toString()).length > 9) return "Overflow";
  const n = ("000000000" + num).substr(-9).match(/^(\d{2})(\d{2})(\d{2})(\d{3})$/);
  if (!n) return;
  let str = "";
  str += (n[1] !== 0) ? (a[Number(n[1])] || b[n[1][0]] + " " + a[n[1][1]]) + " Crore " : "";
  str += (n[2] !== 0) ? (a[Number(n[2])] || b[n[2][0]] + " " + a[n[2][1]]) + " Lakh " : "";
  str += (n[3] !== 0) ? (a[Number(n[3])] || b[n[3][0]] + " " + a[n[3][1]]) + " Thousand " : "";
  str += (n[4] !== 0) ? (a[Number(n[4])] || b[n[4][0]] + " " + a[n[4][1]]) + " " : "";
  return str.trim() + " Only";
};

export const RAZORPAY_API_KEY = "rzp_test_RuAvqVfkt9lJR0";
export const RAZORPAY_SECERT_KEY = "GX9aRQUW34HoD8xyZ0MUZKv9";
